import{a as e,d as n}from"./chunk-XS7CS5U7.js";import{a as c}from"./chunk-PFLRO7TB.js";import{e as t}from"./chunk-2GRXAK7S.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();n();function u(r){e.dispatch(t(r))}export{u as a};
//# sourceMappingURL=chunk-LMU4ZWKG.js.map
